import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, Box, Typography, DialogContent, Divider, DialogActions, Button, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useGetCompletedOrdersByInvoiceIdQuery } from 'src/_api/mapitShipInvoice';
import DataTable from 'src/components/common/DataTables/DataTable';

const $COLUMN_WIDTH = 200;
export default function InvoiceOrdersDialog({ open, onClose, invoiceId }) {
    const { t } = useTranslation();
    const theme = useTheme();

    //===========Get completed and returned orders===========
    const [completedOrdersPage, setCompletedOrdersPage] = useState(1);
    const {
        data: completedOrders,
        isLoading: completedOrdersLoading,
        isFetching: completedOrdersFetching
    } = useGetCompletedOrdersByInvoiceIdQuery({ invoiceId, page: completedOrdersPage }, { skip: (open && invoiceId) ? false : true });

    //===========Tabs===========
    const [rowCount, setRowCount] = useState(0);

    useEffect(() => {
        if (!!completedOrders) {
            setRowCount(completedOrders?.totalDocs)
        }
    }, [completedOrders])

    //===========Data table=========

    const getCustomerName = params => params.row.user.name;

    const columns = [
        { field: "orderNumber", sortable: false, headerName: t("Order No."), width: $COLUMN_WIDTH * 0.75 },
        { field: "amountPayable", sortable: false, headerName: t("Total amount"), width: $COLUMN_WIDTH * 0.7 },
        { field: "otoIntegration", valueGetter: ({ value }) => value?.boxes?.length, sortable: false, headerName: t("Boxes count"), width: $COLUMN_WIDTH * 0.7 },
        { field: "customerName", sortable: false, valueGetter: getCustomerName, headerName: t("Customer Name"), width: $COLUMN_WIDTH * 1.1 },
        { field: "user", sortable: false, valueGetter: ({ value }) => !!value?.phone ? `${value?.phoneCode}${value?.phone}` : '', headerName: t("Phone"), width: $COLUMN_WIDTH * 1.1 },
        { field: "statusTrack", sortable: false, valueGetter: ({ value }) => (!!value?.length && value[0]?.dateTime) ? moment(value[0]?.dateTime).format("DD/MM/YY - h:mm A") : t("Not flagged as delivered yet"), headerName: t("Delivery Date"), width: $COLUMN_WIDTH * 1 },
    ];

    //===========Close Dialog Handler=========

    const closeDialogHandler = () => {
        onClose();
        setCompletedOrdersPage(1);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            dir={theme.direction}
        >
            <DialogTitle>{t("Invoice orders")}</DialogTitle>
            <Divider />
            <DialogContent>
                <Box sx={{ height: "500px" }}>
                    <DataTable
                        tableId="DATA-TABLE-ID-1"
                        rows={completedOrders?.docs ?? []}
                        columns={columns}
                        loading={completedOrdersLoading || completedOrdersFetching}
                        rowCount={rowCount}
                        page={completedOrdersPage}
                        pageSize={20}
                        onRowClick={() => { }}
                        onPageChange={(page) => setCompletedOrdersPage(page)}
                        checkboxSelection={false}
                        customComponents={["Pagination"]}
                    />
                </Box>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    onClick={closeDialogHandler}
                    variant="contained"
                    sx={{ textTransform: 'none' }}
                >
                    {t("Close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
